import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { regionRedirectEndpointMiddleware, regionRedirectEndpointMiddlewareOptions } from "./region-redirect-endpoint-middleware";
export function regionRedirectMiddleware(clientConfig) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var _err$$metadata, _err$$metadata2, _context$logger, actualRegion;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return next(args);
              case 3:
                return _context.abrupt("return", _context.sent);
              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                if (!clientConfig.followRegionRedirects) {
                  _context.next = 30;
                  break;
                }
                if (!((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$$metadata = _context.t0.$metadata) === null || _err$$metadata === void 0 ? void 0 : _err$$metadata.httpStatusCode) === 301 || (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$$metadata2 = _context.t0.$metadata) === null || _err$$metadata2 === void 0 ? void 0 : _err$$metadata2.httpStatusCode) === 400 && (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.name) === "IllegalLocationConstraintException")) {
                  _context.next = 30;
                  break;
                }
                _context.prev = 10;
                actualRegion = _context.t0.$response.headers["x-amz-bucket-region"];
                if (!((_context$logger = context.logger) === null || _context$logger === void 0)) {
                  _context.next = 16;
                  break;
                }
                void 0;
                _context.next = 23;
                break;
              case 16:
                _context.t1 = _context$logger;
                _context.t2 = "Redirecting from ";
                _context.next = 20;
                return clientConfig.region();
              case 20:
                _context.t3 = _context.sent;
                _context.t4 = _context.t2.concat.call(_context.t2, _context.t3, " to ").concat(actualRegion);
                _context.t1.debug.call(_context.t1, _context.t4);
              case 23:
                context.__s3RegionRedirect = actualRegion;
                _context.next = 29;
                break;
              case 26:
                _context.prev = 26;
                _context.t5 = _context["catch"](10);
                throw new Error("Region redirect failed: " + _context.t5);
              case 29:
                return _context.abrupt("return", next(args));
              case 30:
                throw _context.t0;
              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6], [10, 26]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
}
export var regionRedirectMiddlewareOptions = {
  step: "initialize",
  tags: ["REGION_REDIRECT", "S3"],
  name: "regionRedirectMiddleware",
  override: true
};
export var getRegionRedirectMiddlewarePlugin = function getRegionRedirectMiddlewarePlugin(clientConfig) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(regionRedirectMiddleware(clientConfig), regionRedirectMiddlewareOptions);
      clientStack.addRelativeTo(regionRedirectEndpointMiddleware(clientConfig), regionRedirectEndpointMiddlewareOptions);
    }
  };
};